import { useSuggestionsShallowSelector } from 'components/WorkspaceEditor/SuggestionStore'
import { useCallback } from 'react'
import { useTrackChangeCards } from '.'

/**
 * useHandleCardPositions is a custom hook that handles the positions of suggestion cards.
 * It checks if the current suggestion card filter is the default one,
 * and if so, it triggers a debounced update of card positions.
 * @returns {Object} A function that, when called, updates the card positions if the filter is the default.
 */
type HandleCardPositions = () => Promise<void>

export const useHandleCardPositions = (): HandleCardPositions => {
    const { setResetSuggestionScroll } = useSuggestionsShallowSelector(
        (state) => ({
            setResetSuggestionScroll: state.setResetSuggestionScroll,
        })
    )
    const {
        debouncedUpdateCardPositions,
        isNotDefaultSuggestionCardFilter,
    } = useTrackChangeCards()

    const handleCardPositions = useCallback(async () => {
        if (isNotDefaultSuggestionCardFilter) return
        setResetSuggestionScroll(true)
        await debouncedUpdateCardPositions()
    }, [
        debouncedUpdateCardPositions,
        isNotDefaultSuggestionCardFilter,
        setResetSuggestionScroll,
    ])

    return handleCardPositions
}
